import { DB_STRING_ELDRITCH_ADEPT, DB_STRING_MEDIUM_ARMOR_MASTER } from '../Core';
import { getName } from './accessors';
/**
 *
 * @param feat
 */
export function isEldritchAdept(feat) {
    return getName(feat) === DB_STRING_ELDRITCH_ADEPT;
}
export function isMediumArmorMaster(feat) {
    return getName(feat) === DB_STRING_MEDIUM_ARMOR_MASTER;
}
